import { Box, SimpleGrid, Text } from "@chakra-ui/react"

// Fields of a SheetSection (ADR 0005, D1 revised): a two-column grid; each field has its label
// in small muted capitals above a larger value.
export const SheetFieldGrid: React.FC<React.PropsWithChildren> = ({ children }) => (
  <SimpleGrid as="dl" columns={{ base: 1, md: 2 }} columnGap="10" rowGap="7">
    {children}
  </SimpleGrid>
)

type FieldProps = React.PropsWithChildren<{
  label: React.ReactNode
}>

export const SheetField: React.FC<FieldProps> = ({ label, children }) => (
  <Box minW={0}>
    <Text
      as="dt"
      fontSize="3xs"
      fontWeight="normal"
      letterSpacing="widest"
      textTransform="uppercase"
      color="textMuted"
      mb="1"
    >
      {label}
    </Text>
    <Text as="dd" textStyle="p2" color="text" overflowWrap="anywhere">
      {children}
    </Text>
  </Box>
)
